/**
 * Desktop-only lazy loader for Shop mega menu JS + CSS (min-width: 990px).
 * Mobile uses the drawer menu; .shop-mega__content is hidden below 990px.
 */
(function () {
  if (window.__megaMenuShopLoaderInit) return;
  window.__megaMenuShopLoaderInit = true;

  var DESKTOP_MQL = window.matchMedia('(min-width: 990px)');
  var root = document.querySelector('mega-menu-shop[data-script-url]');
  if (!root) return;

  var cssLoaded = false;
  var jsPromise;

  function isDesktop() {
    return DESKTOP_MQL.matches;
  }

  function loadCss() {
    if (cssLoaded || !root.dataset.cssUrl) return;
    cssLoaded = true;
    if (document.querySelector('link[data-deferred-mega-menu-shop-css]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = root.dataset.cssUrl;
    link.media = 'all';
    link.dataset.deferredMegaMenuShopCss = 'true';
    document.head.appendChild(link);
  }

  function loadJs() {
    if (!isDesktop()) return Promise.resolve();
    if (jsPromise) return jsPromise;
    loadCss();
    jsPromise = new Promise(function (resolve, reject) {
      if (customElements.get('mega-menu-shop')) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = root.dataset.scriptUrl;
      script.defer = true;
      script.dataset.deferredMegaMenuShop = 'true';
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
    return jsPromise;
  }

  window.ensureMegaMenuShop = loadJs;

  function arm() {
    if (!isDesktop()) return;
    loadJs();
  }

  if (isDesktop()) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        loadCss();
      });
    } else {
      window.setTimeout(loadCss, 1200);
    }
  }

  root.addEventListener('mouseenter', arm, { passive: true });
  root.addEventListener('focusin', arm, { passive: true });

  DESKTOP_MQL.addEventListener('change', function (event) {
    if (!event.matches) return;
    loadCss();
  });
})();
